import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const iconMap = {
  event: (
    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
  ),
  social: (
    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
    </svg>
  ),
  digital: (
    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  construction: (
    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </svg>
  ),
};

export default function ServiceCard({ service, index }) {
  const icon = iconMap[service.icon] || iconMap.event;

  return (
    <Link to={`/services/${service.id}`}>
      <motion.article
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{
          duration: 0.5,
          delay: index * 0.1,
          ease: [0.22, 1, 0.36, 1],
        }}
        whileHover={{ y: -6 }}
        className="group relative rounded-xl border border-gold-muted/30 overflow-hidden bg-gradient-to-b from-aura-bg via-aura-text to-black hover:border-gold-primary/60 transition-colors duration-300 h-full block"
      >
        <div className="absolute inset-0 bg-gradient-to-tr from-gold-primary/18 via-transparent to-gold-light/8 opacity-80" aria-hidden />
        <div className="relative p-8 md:p-10">
          <div className="flex items-start justify-between gap-4">
            <div className="w-14 h-14 rounded-sm bg-gold-primary/20 text-gold-dark flex items-center justify-center group-hover:bg-gold-primary/35 transition-colors duration-300">
              {icon}
            </div>
            <span className="inline-flex rounded-full border border-gold-light/50 bg-black/30 px-3 py-1 text-[11px] font-sans uppercase tracking-[0.2em] text-gold-light/90">
              {service.title.split("&")[0].trim()}
            </span>
          </div>
          <h3 className="mt-6 font-serif text-xl md:text-2xl font-semibold text-white">
            {service.title}
          </h3>
          <p className="mt-4 font-sans text-sm text-gold-light/90 leading-relaxed">
            {service.description}
          </p>
          <div className="mt-6 flex items-center gap-2 font-sans text-sm font-medium text-gold-primary group-hover:gap-3 transition-all">
            <span>View service details</span>
            <span aria-hidden>→</span>
          </div>
        </div>
      </motion.article>
    </Link>
  );
}
